import { addOneYear, formatDateTime, TimeFormatType } from '../../../utils/date';

export const DEFAULT_START_TIME = '00:00';
export const DEFAULT_END_TIME = '23:59';
export const DEFAULT_START_DATE = formatDateTime(new Date(), TimeFormatType.SHORTDATE);
export const DEFAULT_END_DATE = formatDateTime(addOneYear(new Date()), TimeFormatType.SHORTDATE);
export const DEFAULT_TAG_ACTIVE = '0';
export const DEFAULT_EMERGENCY = '0';
export const DEFAULT_SPECIAL = '0';
